const MEGA_NAV_SELECTOR = '.js-meganav'
const MEGA_NAV_ITEMS_SELECTOR = '.js-meganav-items'
const MEGA_NAV_CONTENT_SELECTOR = '.js-meganav-content'
const MEGA_NAV_HOVER_SELECTOR = '.js-meganav-hover'
const MEGA_NAV_OPEN_FIRST_SELECTOR = '.js-open-first-meganav-content'
const ACTIVE_CLASS = 'is-active'
const MEGA_NAV_PADDING = 60

// ARIA selectors
const TABLIST_SELECTOR = '[role="tablist"]'
const TAB_SELECTOR = '[role="tab"]'

export default () => {
  const megaNavItems = document.querySelectorAll(MEGA_NAV_ITEMS_SELECTOR)
  const openFirstItemMenuEl = document.querySelector(MEGA_NAV_OPEN_FIRST_SELECTOR)

  const openMenu = (itemEl, panelEl) => {
    itemEl?.classList.add(ACTIVE_CLASS)
    panelEl?.classList.add(ACTIVE_CLASS)
    panelEl?.removeAttribute('hidden')
  }

  const closeMenu = (itemEl, panelEl) => {
    itemEl?.classList.remove(ACTIVE_CLASS)
    panelEl?.classList.remove(ACTIVE_CLASS)
    panelEl?.setAttribute('hidden', '')
  }

  const initMegaMenu = () => {
    megaNavItems.forEach(megaNavItem => {
      const megaNavContentEl = megaNavItem.querySelector(MEGA_NAV_CONTENT_SELECTOR)
      megaNavItem.classList.remove(ACTIVE_CLASS)
      megaNavContentEl?.classList.remove(ACTIVE_CLASS)
      megaNavContentEl?.setAttribute('hidden', '')
    })
  }

  const handleHeightMegaMenu = (megaNav, megaNavContentEl) => {
    const megaNavContentHeight = megaNavContentEl ? megaNavContentEl.offsetHeight : 0
    const headerHeight = Number(document.documentElement.style.getPropertyValue('--height-header').replace('px', '')) || 0
    const screenHeight = window.innerHeight

    if (megaNavContentHeight + MEGA_NAV_PADDING * 2 > screenHeight) {
      megaNav.style.setProperty('--overflow-y', 'auto')
      megaNav.style.height = `${screenHeight - headerHeight}px`
      megaNavContentEl.style.paddingBottom = `30px`
    } else {
      megaNav.style.setProperty('--overflow-y', 'visible')
      megaNav.style.height = `${megaNavContentHeight + MEGA_NAV_PADDING}px`
      megaNavContentEl.style.paddingBottom = `0`
    }
  }

  const openFirstItemMenu = (panelEl) => {
    const megaNav = panelEl.closest(MEGA_NAV_SELECTOR)
    if (!megaNav) return
    const megaNavHeight = megaNav.offsetHeight
    const megaNavContentHeight = panelEl ? panelEl.offsetHeight : 0
    megaNav.style.minHeight = `${megaNavHeight}px`
    megaNav.style.height = `${megaNavContentHeight + MEGA_NAV_PADDING}px`
  }

  const getPanelForTab = (tab) => {
    const id = tab.getAttribute('aria-controls')
    return id ? document.getElementById(id) : null
  }

  const getTabsInSameList = (tab) => {
    const list = tab.closest(TABLIST_SELECTOR)
    return list ? Array.from(list.querySelectorAll(TAB_SELECTOR)) : [tab]
  }

  const activateTab = (tab, { focus = false } = {}) => {
    const tabs = getTabsInSameList(tab)
    const megaNav = tab.closest(MEGA_NAV_SELECTOR)

    tabs.forEach(t => {
      const isActive = t === tab
      const panel = getPanelForTab(t)
      t.setAttribute('aria-selected', isActive ? 'true' : 'false')
      t.setAttribute('tabindex', isActive ? '0' : '-1')
      const itemEl = t.closest(MEGA_NAV_ITEMS_SELECTOR)
      if (isActive) {
        openMenu(itemEl, panel)
        if (megaNav && panel) {
          handleHeightMegaMenu(megaNav, panel)
        }
      } else {
        closeMenu(itemEl, panel)
      }
    })

    if (focus) tab.focus()
  }

  const wireKeyboard = (tab) => {
    tab.addEventListener('keydown', (e) => {
      const tabs = getTabsInSameList(tab)
      const idx = tabs.indexOf(tab)
      const last = tabs.length - 1

      const tablist = tab.closest(TABLIST_SELECTOR)
      const orientation = tablist?.getAttribute('aria-orientation') || 'horizontal'
      const prev = () => activateTab(tabs[(idx - 1 + tabs.length) % tabs.length], { focus: true })
      const next = () => activateTab(tabs[(idx + 1) % tabs.length], { focus: true })

      if (orientation === 'vertical') {
        if (e.key === 'ArrowUp') { e.preventDefault(); prev(); }
        if (e.key === 'ArrowDown') { e.preventDefault(); next(); }
      } else {
        if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      }
      if (e.key === 'Home') { e.preventDefault(); activateTab(tabs[0], { focus: true }) }
      if (e.key === 'End') { e.preventDefault(); activateTab(tabs[last], { focus: true }) }
    })
  }

  if (megaNavItems && megaNavItems.length) {
    megaNavItems.forEach(megaNavItem => {
      const megaNavItemHover = megaNavItem.querySelector(MEGA_NAV_HOVER_SELECTOR)
      const megaNav = megaNavItem.closest(MEGA_NAV_SELECTOR)
      if (!megaNavItemHover || !megaNav) return

      const megaNavHeight = megaNav.offsetHeight
      megaNav.style.minHeight = `${megaNavHeight}px`

      megaNavItemHover.addEventListener('mouseenter', () => {
        const tab = megaNavItem.querySelector(TAB_SELECTOR)
        if (tab) {
          activateTab(tab, { focus: false })
        } else {
          // Fallback to old behavior if no ARIA roles found
          const megaNavContentEl = megaNavItem.querySelector(MEGA_NAV_CONTENT_SELECTOR)
          initMegaMenu()
          openMenu(megaNavItem, megaNavContentEl)
          handleHeightMegaMenu(megaNav, megaNavContentEl)
        }
      })
    })
  }

  document.querySelectorAll(TAB_SELECTOR).forEach(tab => {
    tab.addEventListener('click', () => activateTab(tab))
    wireKeyboard(tab)
  })

  document.querySelectorAll(TABLIST_SELECTOR).forEach(list => {
    const tabs = list.querySelectorAll(TAB_SELECTOR)
    const selected = Array.from(tabs).find(t => t.getAttribute('aria-selected') === 'true')
    if (!selected && tabs.length) activateTab(tabs[0])
  })

  if (openFirstItemMenuEl) {
    openFirstItemMenu(openFirstItemMenuEl)
  }
}
